import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { videoApi } from "../api/videoApi";
import { PAGINATION } from "../constants/common";

export const useVideos = (params) => {
  const queryKey = ["/videos", params];
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: async () => await videoApi.getAll(params),
  });

  const create = useMutation({
    mutationFn: async (body) => await videoApi.create(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const update = useMutation({
    mutationFn: async ({ id, body }) => await videoApi.update(id, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const remove = useMutation({
    mutationFn: async (id) => await videoApi.remove(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination || PAGINATION,
    total: data?.pagination.total || 0,
    loading: isLoading,
    error,
    create,
    update,
    remove,
  };
};

export const useVideo = (id) => {
  const queryKey = ["/video", id];

  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: async () => await videoApi.getById(id),
  });

  return {
    data,
    loading: isLoading,
    error,
  };
};
